import React, { useState, useEffect } from 'react'
import Button from '../../common/Button'
import ImModuleStyle from '../styles/im.module.css';

const OrderTable = ({ simObj, setSimObj, placeOrder, toggleSimulation, isShowPlaceOrder, orderState, simPopup }) => {
  const [quantity, setQuantity, shippingType, setShippingType,isRequestLoading] = orderState;
  const [isvalidQty, setIsvalidQty] = useState(false);
  const [isStyleTagPresent, setIsStyleTagPresent] = useState(false); //Added for stylus tool text-spacing change

  let costPerUnit = 0, expediteShippingCostPerUnit = 0, expediteShippingDays = 0, maximumPlacedOrder = 0, minimumPlacedOrder = 0, normalShippingCost = 0, normalShippingDays = 0, shippingOptions = [];
  simObj.actions?.map(function (action) {
    costPerUnit = action.options.costPerUnit;
    expediteShippingCostPerUnit = action.options.expediteShippingCostPerUnit;
    expediteShippingDays = action.options.expediteShippingDays;
    maximumPlacedOrder = action.options.maxOrders;
    minimumPlacedOrder = action.options.minOrders;
    normalShippingCost = action.options.normalShippingCost;
    normalShippingDays = action.options.normalShippingDays;
    shippingOptions = action.options.shippingOptions?.filter((item, position) => action.options.shippingOptions.indexOf(item) == position);
  })
  const charges = {
    "NORMAL_SHIPPING": normalShippingCost,
    "EXPEDITE_SHIPPING": (expediteShippingCostPerUnit * quantity) + normalShippingCost
  }
  const calculateTotalCost = () => {
    return (charges[shippingType] + (quantity * costPerUnit))
  }
  const quantityValidation = (e) => { 
    if (e.target.value != 0 && e.target.value.length != 0 && e.target.value.length <= 4) {
      setQuantity(Number(e.target.value));
      (Number(((Number(e.target.value) % 50) == 0 && (Number(e.target.value) <= 4000)) ? setIsvalidQty(false) : setIsvalidQty(true)))
    } else if(e.target.value.length <= 4){
      setIsvalidQty(true);
      setQuantity(e.target.value == "" ? "" : e.target.value.length <= 4 ? e.target.value : Number(e.target.value.substring(0,4)));
      (Number(e.target.value.substring(0,4)) % 50 == 0 && Number(e.target.value) != 0 && (Number(e.target.value) <= 4000))? setIsvalidQty(false) : setIsvalidQty(true)
    }
  }
  const isReadOnly = ((simObj.status != 'COMPLETED') && (!toggleSimulation && !isRequestLoading) && (simObj.laststate?.quantityordered == 0)) ? false : true;
  useEffect(() => {
    setSimObj({
      ...simObj, actions:
        simObj.actions?.map((action) => ({
          ...action,
          type: "PlaceOrder",
          quantity: !(quantity) ? 50 : quantity,
          shippingType: shippingType
        }))
    });
  }, [quantity, shippingType])

  //Added for stylus tool
  useEffect(() => {
    const checkStyleTag = () => {
      const styleTag = document.querySelector('style.stylus');
      setIsStyleTagPresent(!!styleTag); 
    };
    checkStyleTag();
    const intervalId = setInterval(checkStyleTag, 500); // Check every 500ms
    return () => clearInterval(intervalId);  // Clean up interval when component unmounts
  }, []);

  return (
    <div className={`${ImModuleStyle['place-order']} ${simPopup ? `show ${ImModuleStyle['show']}` : ''}`}>
      <div className={`${ImModuleStyle['item-table']}`}>
        <table>
          <thead>
            <tr>
              <th>Item</th>
              <th className={`center aligned`}>Units</th>
              <th className={`center aligned`}>Rate</th>
              <th className={`center aligned`}>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Amulet 2.0</td>
              <td className={`center aligned`}>
                <input type="number" aria-label="Quantity" disabled={isReadOnly} autoComplete="off" value={quantity} id={`${ImModuleStyle.qtyInput}`} min={minimumPlacedOrder} max={maximumPlacedOrder} step="50" onChange={quantityValidation} />
              </td>
              <td className={`center aligned`}>${costPerUnit}/unit</td>
              <td className={`center aligned`}>${(costPerUnit * quantity).toLocaleString('en-US', { style: 'decimal' })}</td>
            </tr>
            <tr>
              <td id='shippingHeader'>Shipping</td>
              <td colSpan="2">
                <div role='radiogroup' aria-labelledby='shippingHeader'>
                  {
                    shippingOptions?.map((option, index) =>
                      (option == "NORMAL_SHIPPING") && <div className={`${ImModuleStyle.radio1} ${ImModuleStyle['td-width']}`} key={index}>
                        <input type="radio" id={option} value={option} disabled={isReadOnly} name="shippingType" checked={shippingType == option} onChange={() => setShippingType(option)} onKeyDown={(e)=> e.key == "Enter" && e.target.closest("input").click()} />
                        <label id={`${option}-label`} htmlFor={option}>Normal ({normalShippingDays} days)</label>
                      </div>)
                  }
                  {
                    shippingOptions?.map((option, index) =>
                      (option == "EXPEDITE_SHIPPING") && <div className={`${ImModuleStyle.radio2} ${ImModuleStyle['td-width']}`} key={index}>
                        <input type="radio" id={option} value={option} disabled={isReadOnly} name="shippingType" checked={shippingType == option} onChange={() => setShippingType(option)} onKeyDown={(e)=> e.key == "Enter" && e.target.closest("input").click()} />
                        <label id={`${option}-label`} htmlFor={option}>Expedite ({expediteShippingDays} days)</label>
                      </div>)
                  }
                </div>
              </td>
              <td className={`center aligned`}>
                {
                  shippingOptions?.map((option, index) =>
                    (option == "NORMAL_SHIPPING") && <p key={index} aria-description={`normal shipping cost`}>${charges["NORMAL_SHIPPING"].toLocaleString('en-US', { style: 'decimal' })}</p>)
                }
                {
                  shippingOptions?.map((option, index) =>
                    (option == "EXPEDITE_SHIPPING") && <p key={index} aria-description={`expedite shipping cost`}>${charges["EXPEDITE_SHIPPING"].toLocaleString('en-US', { style: 'decimal' })}</p>)
                }
              </td>
            </tr>
            <tr>
              <td><Button btnName="Place Order" disabled={isvalidQty || isReadOnly} clickEventHandler={placeOrder} btnId="placeOrderButton" btnParentClassName="place-order-btn" btnWidth={ isStyleTagPresent ? "125" : "105"} /></td>
              <td colSpan="2" className={`right aligned`}>Order Cost</td>
              <td className={`center aligned`}>${calculateTotalCost().toLocaleString('en-US', { style: 'decimal' })}</td>
            </tr>
            
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default OrderTable